import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "pet__icon / 24px / ic_arrow_left",
		children: [/* @__PURE__ */ _jsx("circle", {
			id: "pet__Ellipse 1",
			cx: 12,
			cy: 12,
			r: 11.5,
			stroke: "#AAAAAA"
		}), /* @__PURE__ */ _jsx("path", {
			id: "pet__Vector",
			fill: "#AAAAAA",
			d: "M15 7.07273L13.9323 6L8 12L13.9383 18L15 16.9273L10.1234 12L15 7.07273Z"
		})]
	})
});
const ForwardRef = forwardRef(SvgArrowLeft);
export default ForwardRef;
